/* eslint-disable no-lonely-if */
/* eslint-disable complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
// import { getApiDTNZFormat } from 'helpers';
import { openConfirmation } from 'helpers/Confirmation';
import { Formik } from 'formik';
import Select from 'react-select';
import { cohortTextLength, cohortDescriptionLength, cohortReasonLength } from 'appconstants';
import { EditableField, FormFieldCell, getTodayFormatted } from './Arms/FieldHelpers';



const EditArmCohort = ({
  data,
  setEditing,
  prtId,
  saveHandler,
  cohortData,
  editableFields,
  actualAccuralTarget,
  accuralTargetSumActive
}) => {
  const {
    cohortName,
    status,
    statusReason,
    statusDate,
    accrualTarget,
    description,
    currentAccrual,
    reservedSlot
  } = data;

  const statusRecordOptions = [
    { label: "Open", value: "OPEN" },
    { label: "Closed", value: "CLOSED" }
  ];

  const initialValues = {
    cohortName: cohortName || '',
    status: status ? statusRecordOptions.find(option => option.value === status) : { label: "Open", value: "OPEN" },
    statusReason: statusReason || '',
    statusDate: statusDate || getTodayFormatted(),
    accrualTarget: accrualTarget || '',
    description: description || '',
    currentAccrual: currentAccrual || '',
    reservedSlot: reservedSlot || ''
  };


  const handleSave = (values) => {

    // 1. Validation
    if (values.status.value === 'CLOSED' && data.stratums?.some(s => s.status === 'OPEN')) {
      openConfirmation({
        message: 'The cohort status cannot be changed as there is at least one open arm.',
        title: 'Status Change Not Allowed',
        hideButton1: true,
        btn2: 'Close'
      });
      return;
    }

    const finalizeSave = (updatedValues) => {
      // const statusDateVal = getApiDTNZFormat(updatedValues.statusDate);
      const editedCohortData = { ...updatedValues, status: updatedValues.status.value }
      const cohortObj = { ...data, ...editedCohortData };
      delete cohortObj.stratums;
      delete cohortObj.arms;
      delete cohortObj.statusDate;
      delete cohortObj.reservedSlot;
      // saveHandler({ ...cohortObj, statusDate: statusDateVal, prtId }, setEditing);
      saveHandler({ ...cohortObj, prtId }, setEditing);
    };


    // 2. Prepare Data
    const valuesToSave = { ...values };
    if (values.status.value !== status && values.status.value !== 'CLOSED') {
      valuesToSave.statusDate = getTodayFormatted();
    }

    const onConfirmAction = () => finalizeSave(valuesToSave);

    // 3. Conditional Confirmation
    if (values.status.value === 'CLOSED' && values.status.value !== status) {
      // if ((values.currentAccrual > values.reservedSlot) || (values.currentAccrual === values.reservedSlot)) {
        openConfirmation({
          message: `Please confirm you want to proceed. By updating the status to Closed, no additional patients will be randomized to ${cohortName}: ${description}.`,
          onAction: onConfirmAction,
          title: 'Confirm Status Change',
          btn1: 'Submit',
          btn2: 'Cancel',
          onHover: true,
          hoverText1: 'Submit change to status',
          hoverText2: 'Cancel changes'
        });
      // } else {
      //   openConfirmation({
      //     message: `The cohort has active slot reservations in process. Please contact ctsucontact@westat.com to close the cohort.`,
      //     title: 'Message on failure',
      //     hideButton1: true,
      //     btn2: 'Close'
      //   });
      // }
    } else {
      openConfirmation({
        message: 'Do you want to save cohort record?',
        onAction: onConfirmAction,
        name: 'cohort'
      });
    }
  };

  const validate = (values) => {
    const errors = {};
    let filteredCohorts = null;
    const actualRecordaccuralVal = initialValues.accrualTarget; // hold the actual value from the db

    if (cohortData) {
      filteredCohorts = cohortData.filter(item => item.pmcId !== data.pmcId);
    }
    if (!values.cohortName || values.cohortName.trim() === '') {
      errors.cohortName = 'Cohort is required.';
    }

    if (!values.status || !values.status.value) {
      errors.status = 'Status is required.';
    }
    // test this after having null value for the cohort field from db
    if (values.accrualTarget) {
      const current = parseInt(values.accrualTarget, 10);
      if ( actualAccuralTarget && (((current + accuralTargetSumActive)-actualRecordaccuralVal) > actualAccuralTarget)) {
        errors.accrualTarget = 'Accrual target cannot exceed the accrual target in the Accrual Information grid.';
      }
    }

    if (values.cohortName && editableFields.cohortName) {

      // check for the character count not exceeding 100 limit
      if (values.cohortName?.length > cohortTextLength) {
        errors.cohortName = 'Cannot exceed 3 characters.';
      }

      const cohorts = filteredCohorts?.map(item => item.cohortName.toLowerCase());
      if (cohorts.includes(values.cohortName.toLowerCase().trim())) {
        errors.cohortName = 'Cohort must be unique.';
      }   
    }
    // validate character count for description, reason
    if (values.description && editableFields.description) {

      // check for the character count not exceeding 250 limit
      if (values.description?.length > cohortDescriptionLength) {
        errors.description = 'Cannot exceed 250 characters.';
      }
    }

    if (values.reason && editableFields.reason) {
      // check for the character count not exceeding 500 limit
      if (values.reason?.length > cohortReasonLength) {
        errors.reason = 'Cannot exceed 500 characters.';
      }
    }
    return errors
  }

  const onCancel = () => {
    setEditing(false);
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSave}
        validate={validate}
      >
        {props => (
          <tr>
            <FormFieldCell fieldName="cohortName">
              <EditableField name="cohortName" showError editableFields={editableFields} length={cohortTextLength} />
            </FormFieldCell>

            <FormFieldCell fieldName="description">
              <EditableField name="description" showError editableFields={editableFields} length={cohortDescriptionLength} />
            </FormFieldCell>

            <FormFieldCell fieldName="status">
              <Select
                name="status"
                options={statusRecordOptions}
                onChange={(selectedVal) => {
                  props.setFieldValue("status", selectedVal);
                }}
                value={props.values.status}
                isDisabled={!editableFields?.status}
                className="reactSelect-wrapper"
                classNamePrefix="reactSelect"
                styles={{ control: (provided) => ({ ...provided, minWidth: '8rem' }) }}
                menuPortalTarget={document.body}
              />
            </FormFieldCell>

            <FormFieldCell fieldName="statusDate">
              <EditableField name="statusDate" editableFields={editableFields} />
            </FormFieldCell>

            <FormFieldCell fieldName="statusReason">
              <EditableField name="statusReason" showError editableFields={editableFields} length={cohortReasonLength} />
            </FormFieldCell>

            <FormFieldCell fieldName="accrualTarget" label="Accrual Target">
              <EditableField name="accrualTarget" type="number"  statusField={props.values.status} showError editableFields={editableFields} />
            </FormFieldCell>

            <FormFieldCell fieldName="currentAccrual" label="Current Accrual">
              <EditableField name="currentAccrual" type="number" editableFields={editableFields} />
            </FormFieldCell>

            <FormFieldCell fieldName="reservedSlot" label="Reserved Slot">
              <EditableField name="reservedSlot" type="number" editableFields={editableFields} />
            </FormFieldCell>

            <td>
              <span className="action-icon-container whiteSpace-nowrap">
                <button
                  type="submit"
                  aria-label="Submit"
                  className="grid-fn-btn"
                  title="Submit"
                  disabled={Object.keys(props.errors).length > 0}
                  onClick={props.handleSubmit}
                >
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="save" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="svg-inline--fa fa-save"><path fill="currentColor" d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z" /></svg>
                </button>
                <button
                  onClick={onCancel}
                  aria-label="Cancel"
                  type="button"
                  className="grid-fn-btn close"
                  title="Cancel"
                >
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" className="svg-inline--fa fa-times"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" /></svg>
                </button>
                <button
                  onClick={() => props.resetForm()}
                  aria-label="Reset"
                  type="button"
                  className="grid-fn-btn"
                  title="Reset"
                >
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="undo-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-inline--fa fa-undo-alt"><path fill="currentColor" d="M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z" /></svg>
                </button>
              </span>
            </td>
          </tr>
        )}
      </Formik>
    </>
  );
};

export default EditArmCohort;
